import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VDistpicker from 'v-distpicker'
import store from './store'
import installElementPlus from './plugins/element'
import './assets/css/icon.css'
import Print from '@/utils/print'
import axios from 'axios'
const app = createApp(App)
app.config.globalProperties.$axios = axios
app.config.globalProperties.localpath = '/'
installElementPlus(app)
app.component('v-distpicker', VDistpicker)
    .use(store)
    .use(router)
    .use(Print)
    .mount('#app')